module.exports = __webpack_public_path__ + "img/photoshop.38dc2092.svg";